export { default as start } from '~/assets/images/sprite/star.svg'

export const STATIC_ANIMATION_DURATION = 2000
